import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

/** Password field with a show / hide eye toggle. Other props go to the <input>. */
export default function PasswordInput({ className = "input-swiss", ...props }) {
    const [visible, setVisible] = useState(false);
    return (
        <div className="relative">
            <input
                {...props}
                type={visible ? "text" : "password"}
                className={`${className} pr-11`}
            />
            <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                className="absolute inset-y-0 right-0 flex items-center px-3 text-zinc-500 hover:text-zinc-900"
                aria-label={visible ? "Hide password" : "Show password"}
                title={visible ? "Hide password" : "Show password"}
                data-testid="toggle-password-visibility"
            >
                {visible ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
        </div>
    );
}
